<template>
	<div class="courseView">
		<div class="courseView-center">
			<div class="imgline">
				<img :src="courseimg" style="width: 85%; " />
			</div>
			<div class="box2right">
				<div class="boxright-title">
					<div class="circle1" >
						<div class="circle2bac"> <div class="circle2" style="top: 2px;" :style="bright ? 'background-color: rgba(0,199,133,1);' :'background-color: rgba(164,164,164,1);'"></div> </div>
						<div class="line1"></div>
					</div>
					<div style="text-align: left;  padding-left: 20px;font-family:Alibaba-PuHuiTi-R;font-size: 14px;" :style="bright ? 'color: rgba(0,199,133,1);' :'color: rgba(164,164,164,1);'">{{time}}</div>
				</div>
				<div class="boxright-write">{{title}}</div>
				<div class="boxright-letter">{{write}}</div>
			</div>
		</div>
	</div>
	
</template>

<script>
	
	export default{
		name:'courseView',
		props:{
			courseimg:{
				type:String,
			},
			time:{
				type:String,
			},
			title:{
				type:String,
			},
			write:{
				type:String,
			},
			bright:false,
		},


	}
	
	
</script>

<style>
	
	.courseView{
		/* height: 200px; */
	}
	
	.courseView .courseView-center {
		display: flex;
		flex-direction: row;
		align-items: center;
		/* padding-bottom: 3.125rem; */
	}
	
	.courseView .courseView-center .imgline{
		width: 50%;
		margin: 30px auto;
		/* border: 1px solid red; */
	}
	
	.courseView .courseView-center .imgline img{
		margin: 0 auto;
		width: 90%;
		height: 90%;
	}
	
	.courseView .courseView-center .box2right{
		width: 50%;
		height: 100px;
		display: flex;
		flex-direction: column;
		
	}
	

	
	.courseView .courseView-center .box2right .boxright-title{
		width:auto;
		
	}
	
	.courseView .courseView-center .box2right .boxright-title .circle1{
		position: absolute;
	}
	
	.courseView .courseView-center .box2right .boxright-title .circle1 .circle2bac{
		border: rgba(205,205,205,0.05) 4px solid;
		width: 0.8rem;
		height: 0.8rem;
		/* margin: 0 auto; */
		border-radius: 50%;
		/* margin-top: 18%; */
		top: 5px;
		right: 39%;
		background: #FFFFFF;
		align-items: center;
		position: relative;
		z-index: 111;
	}
	
	.courseView .courseView-center .box2right .boxright-title .circle1 .circle2bac .circle2{
		width: 0.5rem;
		height: 0.5rem;
		border-radius: 50%;
		/* margin: 0 auto; */
		left: 2px;
		position: absolute;
		background-color: #00C785;
		
		/* z-index: 112; */
	}
	
	.courseView .courseView-center .box2right .boxright-title .circle1  .line1{
		height: 400px;
		width: 1px;
		background-color: rgba(194,194,194,1);
		position: absolute;
		top: -130px;
	}
	
	.courseView .courseView-center .box2right .boxright-write{
		text-align: left;
		font-family:Alibaba-PuHuiTi-M;
		width: 85%;
		color:rgba(24,24,24,1);
		margin-left: 20px;
		margin-top: 10px;
		font-size: 14px;
		font-weight:500;
	}
	
	.courseView .courseView-center .box2right .boxright-letter{
		text-align: left;
		width: 85%;
		font-weight:400;
		color:rgba(64,64,64,1);
		margin-left: 20px;
		margin-top: 20px;
		font-size: 10px;
	}
	
	
</style>
